import { Admin } from '../interface'
import format from 'civic-champs-shared/utils/format'

export const adminsSummary = (admins: Admin[]): { numAdmins: number; onlyOneAdmin: boolean; adminName: string } => {
  const numAdmins = admins.length
  const onlyOneAdmin = numAdmins === 1
  const adminName = onlyOneAdmin ? format.name(admins[0].person) : ''
  return { numAdmins, onlyOneAdmin, adminName }
}
